import {
    AfterViewInit,
    ChangeDetectorRef,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    OnDestroy,
    Renderer2,
    inject,
    input,
    viewChild,
} from '@angular/core';
import { NavigationModel } from '@app/shared/models';
import { BehaviorSubject } from 'rxjs';
import { HoverService } from '../item-nav/hover.service';
import { NgClass, AsyncPipe } from '@angular/common';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-subitem-nav',
    templateUrl: './subitem-nav.component.html',
    styleUrls: ['./subitem-nav.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, RouterLinkActive, RouterLink, AsyncPipe, TranslatePipe],
})
export class SubitemNavComponent implements OnDestroy, AfterViewInit {
    private hoverService = inject(HoverService);
    private renderer2 = inject(Renderer2);
    private changeDetectorRef = inject(ChangeDetectorRef);

    submenu = viewChild<ElementRef<HTMLUListElement>>('submenu');
    children = input.required<NavigationModel[]>();
    top = input<number>(0);
    left = input<number>(0);

    topOffset$ = new BehaviorSubject(0);
    isOutsideWindowBounds$ = new BehaviorSubject(false);

    ngAfterViewInit(): void {
        this.renderer2.appendChild(document.body, this.submenu().nativeElement);

        this.handleSubmenuWindowBounds();
    }

    ngOnDestroy(): void {
        this.renderer2.removeChild(document.body, this.submenu().nativeElement);
    }

    onMouseEnterSubmenu(): void {
        this.hoverService.hoverSubitem$.next(true);
    }

    onMouseLeaveSubmenu(): void {
        this.hoverService.hoverSubitem$.next(false);
    }

    onSubitemClick(): void {
        this.hoverService.hoverSubitem$.next(false);
    }

    checkWindowBounds(): void {
        const submenu = this.submenu()?.nativeElement;
        const value = submenu ? submenu.offsetTop + submenu.offsetHeight > window.innerHeight : false;

        this.isOutsideWindowBounds$.next(value);
    }

    handleSubmenuWindowBounds(): void {
        this.topOffset$.next(this.top());
        this.changeDetectorRef.detectChanges();
        this.checkWindowBounds();

        if (this.isOutsideWindowBounds$.value) {
            this.topOffset$.next(this.getCorrectTopOffset());
        }

        this.changeDetectorRef.detectChanges();
    }

    getCorrectTopOffset(): number {
        const submenu = this.submenu().nativeElement;
        return this.top() - submenu.offsetHeight + 36;
    }
}
